import React, { useCallback } from 'react';

import { EnergyLabel } from '../../../Enum/Filters/EnergyLabel';
import { Filter } from '../../../Enum/Filters';
import { Form } from 'react-bootstrap';
import { filterChanged } from '../../../Store/Filter/action';

import { useDispatch } from 'react-redux';
import useGetFilterValue from '../../../Hook/Interest/UseGetFilterValue';

const EnergyLabelFilter: React.FC = () => {
    const dispatch = useDispatch();
    const value = useGetFilterValue(Filter.EnergyLabel);

    const selectEnergyLabel = useCallback(
        (energyLabel: EnergyLabel): void => {
            dispatch(filterChanged(Filter.EnergyLabel, energyLabel));
        },
        [dispatch],
    );

    return (
        <Form className="energy-label-filter" autoComplete="off">
            <Form.Group controlId="energy_label">
                <Form.Label>Energielabel</Form.Label>
                <Form.Control
                    as="select"
                    custom
                    value={value as EnergyLabel}
                    onChange={e => selectEnergyLabel(e.currentTarget.value as EnergyLabel)}
                >
                    <option value={EnergyLabel.Aplusplusplusplus}>{EnergyLabel.Aplusplusplusplus}</option>
                    <option value={EnergyLabel.Aplusplusplus}>{EnergyLabel.Aplusplusplus}</option>
                    <option value={EnergyLabel.Aplusplus}>{EnergyLabel.Aplusplus}</option>
                    <option value={EnergyLabel.Aplus}>{EnergyLabel.Aplus}</option>
                    <option value={EnergyLabel.A}>{EnergyLabel.A}</option>
                    <option value={EnergyLabel.B}>{EnergyLabel.B}</option>
                    <option value={EnergyLabel.C}>{EnergyLabel.C}</option>
                    <option value={EnergyLabel.D}>{EnergyLabel.D}</option>
                    <option value={EnergyLabel.E}>{EnergyLabel.E}</option>
                    <option value={EnergyLabel.F}>{EnergyLabel.F}</option>
                    <option value={EnergyLabel.G}>{EnergyLabel.G}</option>
                </Form.Control>
            </Form.Group>
        </Form>
    );
};

export default EnergyLabelFilter;
